<template>
  <fragment>
 
    <div class="row" v-if="isloading">
      <div class="col-12 text-center">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Caricamento in corso
      </div>
    </div>
    <div class="activities-history">
                                    <div class="activities-history-list" v-if="$store.getters.isInRole('company-note-edit')">
                                        <div class="activities-history-item">                                            
                                            <textarea class="form-control" v-model="content">

                                            </textarea>
                                            <p class="mb-0 text-right mt-2" >
                                              <button class="btn btn-sm btn-primary-rgba" @click="addNote">Aggiungi nota</button>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="activities-history-list" v-for="item in notelist"
        :key="item.noteId">
                                        <div class="activities-history-item" v-if="note==null || item.noteId != note.noteId">
                                          <div class="row">
                                            <div class="col-11"> 
                                              <h6 v-html="item.content.replace(/(?:\r\n|\r|\n)/g, '<br />')"></h6>
                                            <p class="mb-0 mt-2">{{item.lastUpdate | formatDate}}</p>
                                            </div>
                                            <div class="col-1" v-if="$store.getters.isInRole('company-note-edit')">
                                              <div class="dropdown">
                  <button
                    class="btn btn-link l-h-20 p-0 font-18 float-right"
                    type="button"
                    id="CustomdropdownMenuButton8"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="feather icon-more-horizontal-"></i>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="CustomdropdownMenuButton8"
                  >
                    <a class="dropdown-item font-13 cursor-pointer"  v-on:click.stop="editNote(item.noteId)"><span class="feather icon-edit"></span> Modifica</a>
                    <a class="dropdown-item font-13 text-danger cursor-pointer"  v-on:click.stop="removeNote(item.noteId)"><span class="feather icon-trash"></span> Elimina</a>
                  </div>
                                          </div></div>
                                          
                                          
                                        </div>
                                        </div>
                                         <div class="activities-history-item" v-if="note!=null && item.noteId == note.noteId">
                                          <textarea  class="form-control" v-model="item.content"></textarea>
                                                                                    <p class="mb-0 text-right mt-2">
                                              <button class="btn btn-sm btn-primary-rgba" @click="saveNote(item)">Modifica nota</button>
                                              <button class="btn btn-sm btn-danger-rgba" @click="note=null">Annulla</button>
                                            </p>
                                        </div>
                                    </div>
                                   
                                </div>
    <div class="row" v-if="!notelist || notelist.length ==0">
       <div class="col-12"><noresult /></div>
    </div>

    

    
  </fragment>
</template>
<style scoped>
.attachment-filename {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<script>
let vm_scope;
import axios from "axios";
export default {
  name: "notelist",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
    entityType: {
      type: String,
      required: false,
      default: () => "company",
    },
    
  },
  components: {},
  data() {
    return {
      options: [],
      content:"",
      note: null,
      notelist: [],
     
      isloading:false
    };
  },
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
  addNote:function(){
this.note = {
  noteId:this.value,
  entityType : this.entityType,
  entityId : this.value,
  content : this.content
};
this.saveNote();

  },
  editNote:function(id){
this.note = {
  noteId:id,
 
}

  },
  saveNote :function(item){
var me = this;
if(item)
this.note = item;
axios.post("note",this.note).then((response) => {

                           me.loaddata();
                        });
  },
    removeNote:function(id){
      var me = this;
   this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler eliminare la risorsa?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning-rgba",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.delete('note/' + id).then((response) => {

                           me.loaddata();
                        });
                    }
                });

    },
   
    save:function(){

var me = this;
      axios.put(`note`, this.note).then(function (result) {
me.attachment = null;
                   me.loaddata();
                });

return false;
    },
    loaddata: function () {
      this.content = "";
      this.note = null;
      var me = this;
this.isloading = true;
      axios
        .get(`note/list/${me.value}`)
        .then((response) => {
          me.notelist = response.data;
          me.isloading = false;
        });
    },
  },
};
</script>
